import { render } from "./ProgramByCampusChart.vue?vue&type=template&id=de95ad8e&scoped=true"
import script from "./ProgramByCampusChart.vue?vue&type=script&lang=js"
export * from "./ProgramByCampusChart.vue?vue&type=script&lang=js"

import "./ProgramByCampusChart.vue?vue&type=style&index=0&id=de95ad8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-de95ad8e"

export default script